import React, { useEffect } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import BusinessUnits from "@/components/BusinessUnits";
import StatsBar from "@/components/StatsBar";
import Footer from "@/components/Footer";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="home-page" className="min-h-screen bg-emka">
      <Header />
      <Hero />
      <BusinessUnits />
      <StatsBar />
      <Footer />
    </div>
  );
};

export default Home;
